import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import './DeleteMessageDialog.css';
import { I18n } from 'aws-amplify';
import { onSubmitDeleteMsg } from '../handler/MessageHandler';

function DeleteMessageDialog({ argsAll }) {
    const handleCloseConfirmModal = () => {
        argsAll.setOpenModalDeleteMsg({ isOpen: false, msg: null });
    };

    return (
        <Dialog
            open={argsAll.openModalDeleteMsg?.isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <div className="dialog-content">このメッセージを削除してよろしいでしょうか。</div>
            </DialogContent>
            <DialogActions className="dialog-action-delete">
                <Button
                    className="dialog-button-delete"
                    variant="contained"
                    onClick={async () => {
                        await onSubmitDeleteMsg(
                            argsAll.API,
                            argsAll.openModalDeleteMsg.msg,
                            argsAll.setStatusDeleteMsgList,
                            argsAll.statusDeleteMsgList,
                            argsAll.chatPostAllList,
                            argsAll.msgContentList,
                            argsAll.setChatPostUpdate,
                            argsAll.setOpenModalDeleteMsg,
                            argsAll?.ticketInfo,
                            argsAll?.selectThread
                        );
                    }
                    }
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    className="dialog-action-cancel"
                    variant="contained"
                    onClick={() => handleCloseConfirmModal()}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DeleteMessageDialog;
